import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import { User } from 'able-lib'

export default ({ store, Vue }) => {
  if (!process.env.DEV) {
    const user: User = store.state.user.user ? store.state.user.user : { id: 'loggedOut', email: '', firstName: '', lastName: '' }
    Bugsnag.start({
      appVersion: '1.5.3',
      apiKey: '4207fd0a05b7167af35d806f72daf052',
      plugins: [new BugsnagPluginVue()],
      enabledReleaseStages: ['production'],
      releaseStage: process.env.ENVIRONMENT,
      onError: function (event) {
        event.setUser(user.id + '', user.email, user.firstName + ' ' + user.lastName)
        event.addMetadata('company', {
          name: 'ABLE',
          country: 'ph'
        })
      }
    })
    Bugsnag.getPlugin('vue').installVueErrorHandler(Vue)
  }
}

export function sendBugsnagReport (message: string, e?: Error) {
  Bugsnag.notify(e || new Error(message))
}

export function bugsnagBreadCrumb (msg: string) {
  Bugsnag.leaveBreadcrumb(msg)
}
